<template>
  <naj-box :title="local.lawsuitDetails.title">
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.lawsuitDetails.caseSubject"
          :value.sync="proceedingInfo.caseSubject"
          :counter="30000"
          :disabled="mode.isViewMode || auditFields.isSubjectAudited || !isCaseSubjectTextEditable"
          :validates="`${caseHasFormId ? 'required' : 'required|min:160'}`"
          @input="$emit('change')"
        ></naj-input>
        <naj-input
          v-if="isEditMode && !isInternalLawsuit && isNotCompleted"
          :type-id="formFieldType.checkbox"
          :value.sync="auditFields.isSubjectAudited"
          :label="`${local.requestReply.checklist.title} ${local.lawsuitDetails.caseSubject}`"
          class="inline-label primary-label-color"
          :disabled="isAuditFieldsDisabled"
          @change="updateAuditFields({ isSubjectAudited: auditFields.isSubjectAudited })"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.lawsuitDetails.caseDemands"
          :value.sync="proceedingInfo.caseDemands"
          :counter="30000"
          :disabled="mode.isViewMode || auditFields.isDemandsAudited || !isCaseDemandsTextEditable"
          validates="required"
          @input="$emit('change')"
        ></naj-input>
        <naj-input
          v-if="isEditMode && !isInternalLawsuit && isNotCompleted"
          :type-id="formFieldType.checkbox"
          :value.sync="auditFields.isDemandsAudited"
          :label="`${local.requestReply.checklist.title} ${local.lawsuitDetails.caseDemands}`"
          class="inline-label primary-label-color"
          :disabled="isAuditFieldsDisabled"
          @change="updateAuditFields({ isDemandsAudited: auditFields.isDemandsAudited })"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.lawsuitDetails.caseProofs"
          :value.sync="proceedingInfo.caseProofs"
          :disabled="mode.isViewMode || auditFields.isProofsAudited"
          :counter="30000"
          validates="required"
          @input="$emit('change')"
        ></naj-input>
        <naj-input
          v-if="isEditMode && !isInternalLawsuit && isNotCompleted"
          :type-id="formFieldType.checkbox"
          :value.sync="auditFields.isProofsAudited"
          :label="`${local.requestReply.checklist.title} ${local.lawsuitDetails.caseProofs}`"
          class="inline-label primary-label-color"
          :disabled="isAuditFieldsDisabled"
          @change="updateAuditFields({ isProofsAudited: auditFields.isProofsAudited })"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.lawsuitDetails.numberOfAttachments"
          :value.sync="proceedingInfo.numberOfAttachments"
          :disabled="mode.isViewMode"
          :counter="256"
          @input="$emit('change')"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState, mapGetters } = createNamespacedHelpers('LawsuitModule');
export default {
  inject: ['$validator', 'mode'],
  props: {
    proceedingInfo: { type: Object },
    isCaseSubjectTextEditable: { type: Boolean },
    isCaseDemandsTextEditable: { type: Boolean },
    caseHasFormId: { type: Boolean },
  },
  computed: {
    ...mapState({ auditFields: state => state.lawsuitRequest.auditFields }),
    ...mapGetters(['isEditMode', 'isInternalLawsuit', 'isAuditFieldsDisabled', 'isNotCompleted']),
  },
  methods: { ...mapActions(['updateAuditFields']) },
};
</script>
